import type { RowClickHook } from "@/features/integrations/shared/renderer/hooks/types";

/**
 * Registry mapping integration names to their row click hooks.
 */
const rowClickHooksRegistry = new Map<string, RowClickHook>();

/**
 * Register a row click hook for a specific integration in the job-sync module.
 * @param integrationName - The integration name (e.g., "werkzoeken")
 * @param hook - The hook function that returns row click handler
 */
export function registerJobSyncRowClickHook(
  integrationName: string,
  hook: RowClickHook
): void {
  const normalizedName = integrationName.toLowerCase();
  rowClickHooksRegistry.set(normalizedName, hook);
}

/**
 * Get the registered row click hook for an integration.
 * @param integrationName - The integration name
 * @returns The registered hook function, or undefined if not registered
 */
export function getJobSyncRowClickHook(
  integrationName: string | undefined
): RowClickHook | undefined {
  if (!integrationName) return undefined;
  const normalizedName = integrationName.toLowerCase();
  return rowClickHooksRegistry.get(normalizedName);
}
